import React from "react";
import { AMLStatusEnum } from "../../../Enums";

const repeated = (list, filed) =>
  list &&
  list.map((item, index) =>
    !item[filed] ? (
      <span key={index}>
        <span> </span>
      </span>
    ) : (
      <span key={index}>
        {" "}
        {item[filed]} {list.length - 1 != index && <span> , </span>}
      </span>
    )
  );

export const headerData = (t, AMLTransactionStatusList) => [
  {
    id: 1,
    label: "ref-no",
    input: "unitRefNumber",
    component: (item) => <span>{item && item.unitReferenceNo}</span> || "",
  },
  {
    id: 2,
    label: "property",
    input: "propertyName",
  },
  {
    id: 3,
    label: "transaction-status",
    input: "transactionStatusId",
    withSelectFilter: true,
    optionFilterList: [...AMLTransactionStatusList],
    component: (item) =>
      (
        <span>
          {item.transactionStatus === "Pass" ||
          item.transactionStatus === "Approved" ? (
            <span className="pass-lapel">{t(`${item.transactionStatus}`)}</span>
          ) : item.transactionStatus === "Fail" ||
            item.transactionStatus === "Rejected" ? (
            <div className="Fail-lapel">{t(`${item.transactionStatus}`)}</div>
          ) : item.transactionStatus === "Pending" ||
            item.transactionStatus === "WithdrawTransaction" ||
            item.transactionStatus === "ReassignedToRequester" ||
            item.transactionStatus === "NeedRevision" ||
            item.transactionStatus === "Resubmitted" ||
            item.transactionStatus === "AutoWithdraw" ? (
            <div className="Pending-lapel">
              {t(`${item.transactionStatus}`)}
            </div>
          ) : (
            ""
          )}
        </span>
      ) || "",
  },
  {
    id: 4,
    label: "status",
    input: "statusId",
    withSelectFilter: true,
    component: (item) => <span>{item && item.status}</span> || "",

    optionFilterList: [
      {
        key: AMLStatusEnum[6].key,
        value: AMLStatusEnum[6].name,
      },
      {
        key: AMLStatusEnum[5].key,
        value: AMLStatusEnum[5].name,
      },
      {
        key: AMLStatusEnum[10].key,
        value: AMLStatusEnum[10].name,
      },
    ],
  },
  {
    id: 5,
    label: "developer-name",
    input: "developerName",
    isSortable: true,
  },
  {
    id: 6,
    label: "community",
    input: "communityName",
  },
  {
    id: 7,
    isSortable: true,
    label: "transaction-id",
    input: "unitTransactionId",
  },
  {
    id: 8,
    label: "unit-no",
    input: "unitNumber",
  },
  {
    id: 9,
    label: "buyer",
    input: "buyerName",
    component: (item) => (
      <span>
        {item.buyersNames &&
          item.buyersNames.map((element, index) => (
            <span key={`buyersNamesRef${index + 1}`}>
              {`${element}${
                (index < item.buyersNames.length - 1 && ", ") || ""
              }`}
            </span>
          ))}
      </span>
    ),
  },
  {
    id: 10,
    label: "buyer-agent",
    input: "buyerAgent",
    component: (item) =>
      (
        <span>
          {item &&
            item.buyerAgents &&
            item.buyerAgents.map((item) => `${item.agentName} , `)}
        </span>
      ) || "",
  },
  {
    id: 11,
    label: "buyer-team-leads",
    isSortable: true,
    input: "buyerTeamLead",
    component: (item) =>
      (item &&
        item.buyerTeamLeads &&
        Array.isArray(item.buyerTeamLeads) &&
        item.buyerTeamLeads.length > 0 &&
        repeated(item.buyerTeamLeads, "teamLeadName")) ||
      "",
  },
  {
    id: 12,
    label: "buyer-team-managers",
    // isSortable: true,
    input: "buyerTeamManager",
    component: (item) =>
      (item &&
        item.buyerTeamLeads &&
        Array.isArray(item.buyerTeamLeads) &&
        item.buyerTeamLeads.length > 0 &&
        repeated(item.buyerTeamLeads, "teamManager")) ||
      "",
  },
  {
    id: 13,
    label: "buyer-agent-staff-id",
    input: "buyerStaffId",
    component: (item) =>
      (
        <span>
          {item &&
            item.buyerAgents &&
            item.buyerAgents.map((item) =>
              item.staffId ? `${item.staffId} ,  ` : "N/A ,  "
            )}
        </span>
      ) || "",
  },
   {
    id: 14,
    label: "buyer-branch",
    input: "buyerBranch",
  },
  {
    id: 15,
    label: "seller",
    input: "sellerName",
  },
  {
    id: 16,
    label: "seller-agent",
    input: "sellerAgent",
    component: (item) =>
      (
        <span>
          {item &&
            item.sellerAgents &&
            item.sellerAgents.map((item) => `${item.listingAgentName}, `)}
        </span>
      ) || "",
  },
  {
    id: 17,
    label: "seller-team-leads",
    isSortable: true,
    input: "sellerTeamLead",
    component: (item) =>
      (item &&
        item.sellerTeamLeads &&
        Array.isArray(item.sellerTeamLeads) &&
        item.sellerTeamLeads.length > 0 &&
        repeated(item.sellerTeamLeads, "teamLeadName")) ||
      "",
  },
  {
    id: 18,
    label: "seller-team-managers",
    //   isSortable: true,
    input: "sellerTeamManager",
    component: (item) =>
      (item &&
        item.sellerTeamLeads &&
        Array.isArray(item.sellerTeamLeads) &&
        item.sellerTeamLeads.length > 0 &&
        repeated(item.sellerTeamLeads, "teamManager")) ||
      "",
  },
  {
    id: 19,
    label: "seller-agent-staff-id",
    input: "sellerStaffId",
    component: (item) =>
      (
        <span>
          {item &&
            item.sellerAgents &&
            item.sellerAgents.map((item) =>
              item.staffId ? `${item.staffId} ,  ` : "N/A ,  "
            )}
        </span>
      ) || "",
  },
  {
    id: 20,
    label: "seller-branch",
    input: "sellerBranch",
  },
  {
    id: 21,
    isSortable: true,
    label: "selling-price",
    input: "sellingPrice",
  },
  {
    id: 22,
    isSortable: true,
    label: "transaction-date",
    input: "transactionEntryDate",
    isDate: true,
  },
  {
    id: 23,
    label: "notes",
    input: "invoiceNotes",
    isHiddenFilter: true,
  },
  {
    id: 24,
    label: "closing_date",
    input: "closingDate",
    isDate: true
  },
   {
      id: 25,
      label: "Affiliate / Sub-Branch",
      input: "affiliateName",
    }
];
